import { toDisplayValue } from './stringify-value';
import { QUERY_STATUS } from '../query/query-status';
import { FIELD_VALUE_STATES, UNKNOWN_REASONS } from './field-value';

export function classifyFieldValue({ hasRow, entry, normalizedData, key, createsRecord, predecessorStatus }) {
  if (!hasRow) {
    // A record-creating action has no predecessor to retrieve, so a pending or failed lookup cannot change
    // that answer. For every other action, predecessorPruned asserts the retention window ran out
    // — only say that when the lookup actually succeeded and found nothing.
    if (createsRecord) return unknown(UNKNOWN_REASONS.NO_PREDECESSOR);
    if (predecessorStatus === QUERY_STATUS.LOADING) return { state: FIELD_VALUE_STATES.LOADING };
    if (predecessorStatus === QUERY_STATUS.ERROR) return unknown(UNKNOWN_REASONS.PREDECESSOR_UNAVAILABLE);
    return unknown(UNKNOWN_REASONS.PREDECESSOR_PRUNED);
  }
  if (!(key in normalizedData)) {
    return unknown(UNKNOWN_REASONS.KEY_ABSENT_FROM_PREDECESSOR);
  }

  const raw = normalizedData[key];
  const isForeign = (entry.foreignDisplayKeys ?? []).includes(key);
  const isBlank = raw === null || raw === '';

  if (isBlank && isForeign) return unknown(UNKNOWN_REASONS.FOREIGN_LOOKUP_MISSED);
  if (isBlank) return { state: FIELD_VALUE_STATES.EMPTY };

  const isComplex = (entry.complexKeys ?? []).includes(key);
  const { value, truncated } = toDisplayValue(raw, isComplex);
  return { state: FIELD_VALUE_STATES.VALUE, value, truncated };
}

function unknown(reason) {
  return { state: FIELD_VALUE_STATES.UNKNOWN, reason };
}
